{
  "processing": "Processando verificação...",
  "loadingIframe": "Carregando verificação de identidade...",
  "issueTitle": "Problema na verificação de identidade",
  "notConfigured": "A verificação de identidade não está configurada corretamente para este armazém.",
  "notSuccessful": "A verificação de identidade não foi concluída. Por favor, tente novamente ou entre em contato com o armazém.",
  "couldNotCompleteProceed": "A verificação de identidade não pôde ser concluída, mas você pode prosseguir com o check-in.",
  "processFailed": "Falha ao processar a verificação de identidade. Por favor, tente novamente.",
  "processingFailedProceed": "O processamento da verificação de identidade falhou, mas você pode prosseguir com o check-in.",
  "genericError": "Ocorreu um erro durante a verificação de identidade. Por favor, tente novamente.",
  "issueProceed": "A verificação de identidade encontrou um problema, mas você pode prosseguir com o check-in.",
  "requiredTryAgain": "A verificação de identidade é necessária para concluir o check-in. Por favor, tente novamente.",
  "checkInFailedTitle": "Não foi possível fazer o check-in",
  "checkInFailedMessage": "Não foi possível validar seu documento de identidade"
}
